/**
 * Coalesce rapid callbacks (e.g. Mapbox draw.render) to one invocation per animation frame.
 */
export function createRafCoalescer() {
  let rafId = null;
  let pendingArg = undefined;
  let handler = null;

  return {
    schedule(fn, arg) {
      handler = fn;
      pendingArg = arg;
      if (rafId != null) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        const fnToRun = handler;
        const argToRun = pendingArg;
        handler = null;
        pendingArg = undefined;
        if (typeof fnToRun === 'function') fnToRun(argToRun);
      });
    },
    cancel() {
      if (rafId != null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      handler = null;
      pendingArg = undefined;
    }
  };
}
